import { INSTA_ROOT } from '../instaConfig';
import axios from 'axios';

export const InstagramToken = (formData) => {
	
	let headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
	return axios.post(`https://api.instagram.com/oauth/access_token`, formData, headers)
		.then(response => response)
}